import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const omit = <T extends object, K extends keyof T>(
  obj: T,
  keyToOmit: K | K[],
): Omit<T, K> => {
  const keysToOmit = Array.isArray(keyToOmit) ? keyToOmit : [keyToOmit];
  const result = { ...obj };
  for (const key of keysToOmit) {
    delete result[key];
  }
  return result as Omit<T, K>;
};

export const getMimeTypeFromUrlOrFileName = (urlOrFileName: string) => {
  const extension = urlOrFileName.split('.').pop()?.toLowerCase();
  if (extension === 'webp') return 'image/webp';
  if (extension === 'png') return 'image/png';
  if (extension === 'jpg' || extension === 'jpeg') return 'image/jpeg';
  return 'image/jpeg';
};
